export default {
  buttonAnterior: 'Anterior',
  buttonProximo: 'Próximo'
}